var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 25.6116 25.6154 33 16.5 33C7.3884 33 0 25.6154 0 16.5C0 7.3884 7.3884 0 16.5 0C25.6116 0 33 7.3884 33 16.5Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1488 13.4943C27.1488 14.6723 26.1919 15.6293 25.0138 15.6293C23.8358 15.6293 22.8789 14.6723 22.8789 13.4943C22.8789 12.3163 23.8358 11.3594 25.0138 11.3594C26.1957 11.3556 27.1488 12.3125 27.1488 13.4943Z",
    fill: "#562912"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4769 13.4943C10.4769 14.6723 9.51998 15.6293 8.34196 15.6293C7.16393 15.6293 6.20703 14.6723 6.20703 13.4943C6.20703 12.3163 7.16393 11.3594 8.34196 11.3594C9.51998 11.3556 10.4769 12.3125 10.4769 13.4943Z",
    fill: "#562912"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.719 21.7052C25.1413 21.6774 25.5166 21.9812 25.5714 22.4056C25.6311 22.8486 25.3176 23.2514 24.8746 23.3111C22.5562 23.613 20.3824 24.9483 19.062 26.8845C18.8112 27.2525 18.3092 27.3468 17.9412 27.0959C17.5732 26.8451 17.4789 26.3432 17.7298 25.9751C19.3046 23.6668 21.897 22.0747 24.666 21.7126C24.6848 21.7075 24.7 21.7065 24.719 21.7052Z",
    fill: "#562912"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsure);
export default __webpack_public_path__ + "static/media/unsure.51b9547e2dd384bdae8167df03ef565a.svg";
export { ForwardRef as ReactComponent };